// extracted by mini-css-extract-plugin
export default {"logoImage":"Logo__logoImage--3xY"};